export default {
    comments: {
        title: 'Comment List',
        empty: 'No comments',
        fetchFailed: 'Failed to fetch comments',
        deleteSuccess: 'Comment deleted',
        deleteFailed: 'Failed to delete comment',
        deleteConfirm:
            'Soft-delete this comment? Deleting a root comment also soft-deletes unreplied replies.',
        deleteReason: 'Delete reason',
        deleteReasonPlaceholder: 'Enter delete reason',
        deleteReasonRequired: 'Please enter a delete reason',
        deleteSubmit: 'Delete',
        missingOperator: 'Missing operator ID. Please sign in again.',
        exportSuccess: 'Export started. Check Downloads later.',
        exportFailed: 'Export failed',
        preview: 'Preview',
        previewTitle: 'Video preview',
        history: 'History',
        historyTitle: 'Comment history',
        historyEmpty: 'No history',
        historyFetchFailed: 'Failed to fetch comment history',
        historyAction: 'Action',
        historyReason: 'Reason',
        historyOperator: 'Operator',
        historyTime: 'Operated at',
        sort: {
            label: 'Published at',
            asc: 'Ascending',
            desc: 'Descending',
        },
        columns: {
            no: 'No.',
            id: 'Comment ID',
            content: 'Content',
            level: 'Level & context',
            related: 'Related video',
            author: 'Author',
            stats: 'Likes / replies',
            createdAt: 'Published at',
            auditStatus: 'Status',
            action: 'Actions',
        },
        level: {
            root: 'Root comment',
            reply: 'Reply',
            replyTo: 'Reply to @{nickname} (UID: {uid})',
        },
        related: {
            type: 'Type',
            videoId: 'Video ID',
            dramaId: 'Drama ID',
            episode: 'Ep. {n}',
            drama: 'Drama',
            video: 'Video',
        },
        stats: {
            like: 'Likes: {n}',
            reply: 'Replies: {n}',
        },
        search: {
            id: 'Comment ID',
            content: 'Content',
            userId: 'User UID',
            itemType: 'Type',
            workId: 'Video ID',
            level: 'Level',
            auditStatus: 'Status',
            createdAtStart: 'Published from',
            createdAtEnd: 'Published to',
        },
        itemType: {
            all: 'All',
            EPISODE: 'Drama',
            SHORT_VIDEO: 'Video',
        },
        levelFilter: {
            all: 'All',
            root: 'Root',
            reply: 'Reply',
        },
        auditStatus: {
            all: 'All',
            APPROVED: 'Approved',
            DELETED: 'Deleted',
            PENDING: 'Pending',
        },
    },
};
